import adapter from "../../../services/adapters/form_connection";

export default (state, payload) => {
  state.form_connection = payload ? { ...payload } : { ...adapter };
};
